/* Staged DEV integration: load only after removing the native Shopify submit guard. */
window.pyContactReady = () => {
  const form = document.querySelector('[data-contact-direct]');
  if (!form) return;
  const endpoint = form.dataset.endpoint;
  const sitekey = form.dataset.sitekey;
  if (!endpoint || !sitekey) return;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[data-contact-status]');
  const language = document.documentElement.lang;
  const locale = language.startsWith('zh') ? 'zh-TW' : language.slice(0, 2);
  const messages = {
    ja: ['送信中…', '送信しました', '送信できませんでした。時間をおいて再度お試しください。', 'スパム対策の確認を完了してください。'],
    en: ['Sending…', 'Sent', 'Unable to send. Please try again shortly.', 'Please complete the security check.'],
    ko: ['전송 중…', '전송 완료', '전송하지 못했습니다. 잠시 후 다시 시도해 주세요.', '보안 확인을 완료해 주세요.'],
    'zh-TW': ['傳送中…', '已送出', '無法送出，請稍後再試。', '請完成安全驗證。']
  };
  const copy = messages[locale] || messages.en;
  const showStatus = (message, success = false) => {
    status.setAttribute('role', success ? 'status' : 'alert');
    status.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:8px;color:#fff;background:' + (success ? '#218447' : '#b42332') + ';border-radius:8px;padding:14px 18px;margin:16px 0 0;font-size:14px;line-height:1.6;text-align:left;';
    status.innerHTML = success ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style="width:22px;height:22px;flex:none"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" /></svg>' : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" style="width:22px;height:22px;flex:none"><circle cx="12" cy="12" r="9.25"/><path stroke-linecap="round" d="M12 7v6m0 4h.01"/></svg>';
    const text = document.createElement('span');
    text.textContent = message;
    status.append(text);
    button.after(status);
  };
  let busy = false, done = false, requestId = crypto.randomUUID(), previous = '';
  let uploaded = null;
  const input = form.querySelector('[data-contact-files]');
  input.addEventListener('change', () => {
    uploaded = null; requestId = crypto.randomUUID();
    form.querySelector('[data-contact-file-list]').textContent = [...input.files].map(f => f.name).join(' / ');
  });
  const originalLabel = button.textContent;
  button.disabled = false;
  const widget = turnstile.render(form.querySelector('[data-contact-challenge]'), { sitekey, action: 'contact_prod', theme: 'light' });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || done || !form.reportValidity()) return;
    const token = turnstile.getResponse(widget);
    if (!token) { showStatus(copy[3]); return; }
    const value = key => form.elements.namedItem('contact[' + key + ']')?.value || '';
    const data = {
      country_code: form.dataset.countryCode || '', name: value('お名前'), email: value('email'), phone: value('電話番号'),
      order_number: value('注文番号'), inquiry_category: value('お問い合わせ種別'),
      body: value('body'), locale: messages[locale] ? locale : 'en',
      privacy_agreed: form.elements.namedItem('contact[プライバシーポリシーへの同意]')?.checked === true
    };
    const files = [...input.files];
    if (files.length > 3 || files.some(f => !/\.(jpe?g|png|heic|pdf)$/i.test(f.name) || !f.size || f.size > 10*1024*1024)) {
      showStatus(input.dataset.error); return;
    }
    const snapshot = JSON.stringify({...data, files: files.map(f => [f.name,f.size,f.lastModified])});
    if (previous && snapshot !== previous) { requestId = crypto.randomUUID(); uploaded = null; }
    previous = snapshot;
    busy = true; button.disabled = true; button.textContent = copy[0]; status.textContent = ''; status.style.cssText = '';
    form.setAttribute('aria-busy', 'true');
    input.disabled = true;
    try {
      if (files.length && !uploaded) {
        const planResponse = await fetch(endpoint, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...data,id:requestId,challenge_token:token,operation:'prepare_upload',attachments:files.map(f=>({name:f.name,size:f.size}))}),signal:AbortSignal.timeout(20000)});
        const plan = await planResponse.json();
        if (!planResponse.ok || !plan.uploads || plan.uploads.length !== files.length) throw new Error('upload_prepare');
        for (let i=0;i<files.length;i++) {
          const body = new FormData();
          Object.entries(plan.uploads[i].fields).forEach(([k,v])=>body.append(k,v));
          body.append('file',files[i]);
          const up = await fetch(plan.uploads[i].url,{method:'POST',body,signal:AbortSignal.timeout(120000)});
          if (!up.ok) throw new Error('upload_failed_' + up.status);
        }
        uploaded = plan.upload_session;
        turnstile.reset(widget);
        const deadline=Date.now()+60000;
        while (!turnstile.getResponse(widget) && Date.now()<deadline) await new Promise(r=>setTimeout(r,200));
        if (!turnstile.getResponse(widget)) throw new Error('challenge');
      }
      const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, id: requestId, challenge_token: turnstile.getResponse(widget), ...(uploaded ? {upload_session:uploaded} : {}) }), signal: AbortSignal.timeout(20000) });
      const result = await response.json();
      if (!response.ok || result.accepted !== true) throw new Error('not_accepted');
      done = true; button.textContent = copy[1];
      const successMessages = {
        ja: 'お問い合わせを受け付けました。ご回答は最大2営業日いただいておりますので、ご了承いただけますと幸いです。',
        en: 'Your inquiry has been received. Please allow up to 2 business days for a response. Thank you for your understanding.',
        ko: '문의가 접수되었습니다. 답변까지 최대 2영업일이 소요될 수 있으니 양해 부탁드립니다.',
        'zh-TW': '我們已收到您的詢問。回覆最多需要 2 個工作天，敬請見諒。'
      };
      showStatus(successMessages[locale] || successMessages.en, true);
    } catch (error) {
      console.warn('Contact submission stage:', error.message);
      showStatus(copy[2]); button.disabled = false; button.textContent = originalLabel;
    } finally {
      busy = false; input.disabled = done; form.removeAttribute('aria-busy'); turnstile.reset(widget);
    }
  });
};
